'use client'

import React from 'react'
import Image from 'next/image'
import ErrorBoundary from '@components/ErrorBoundary/errorBoundary'
import { convertToSlug } from '@utils/IdGenerator'
import { segmentEventCommonPropFunc } from '@utils/segmentProperties'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { colorConfig } from '@configs/inlineCTABgColors'
import styles from './inlineCTA.module.scss'

const InlineCTA = ({ data }) => {
  const inlineCTAData = data?.data?.attributes

  const handleButtonClick = () => {
    void (async () => {
      const properties = await segmentEventCommonPropFunc(data?.segmentEventCommonProperties)
      void trackEvent('tap_btn_CTA_widget', {
        ...properties,
        journey: 'inline_cta_click',
        ...(inlineCTAData?.properties ? inlineCTAData?.properties : {}),
      })
      window.open(inlineCTAData?.bannerURL, inlineCTAData?.newTab ? '_blank' : '_self')
    })()
  }

  return (
    <ErrorBoundary data={data}>
      <div className={`${styles.inlineCTARootContainer} white skip-child`} id={convertToSlug(inlineCTAData?.title)}>
        <div
          className={styles.inlineCTAContent}
          style={{ background: colorConfig?.[inlineCTAData?.backgroundColor] ?? colorConfig?.Yellow }}>
          <div className={styles.inlineCTAContentLeft}>
            {inlineCTAData?.title && <h2 className={styles.title}>{inlineCTAData?.title}</h2>}
            {inlineCTAData?.subTitle && <p className={styles.subTitle}>{inlineCTAData?.subTitle}</p>}
            <button type="button" className={styles.button} onClick={handleButtonClick} data-testid="inline-cta-button">
              {inlineCTAData?.buttonText || 'Analyse my policy'}
            </button>
          </div>
          <div className={styles.inlineCTAContentRight}>
            {inlineCTAData?.bannerImage?.data?.attributes?.url && (
              <Image
                className={styles.inlineCTAContentRightImage}
                src={inlineCTAData?.bannerImage?.data?.attributes?.url}
                alt={inlineCTAData?.title}
                width={180}
                height={188}
              />
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default InlineCTA
